/* PRODIGY rail behaviour.
   Event-delegated on purpose: the rail is a Shopify section, and the theme
   editor replaces the section's DOM through the Section Rendering API on every
   settings change. Listeners bound to concrete nodes would be discarded with
   the old markup and the nav would go dead until a full reload. Delegating to
   `document` and looking elements up lazily survives any number of re-renders. */
(function () {
  function q(id) { return document.getElementById(id); }

  function setOpen(li, open) {
    var btn = li.querySelector(':scope > button.pdg-item');
    li.classList.toggle('pdg-open', open);
    if (btn) btn.setAttribute('aria-expanded', String(open));
    if (!open) {
      li.querySelectorAll('.pdg-grp.pdg-open').forEach(function (c) { setOpen(c, false); });
    }
  }

  /* One band open at a time. The rail foot is a tight stack now, so letting all
     three unfold at once would push the block taller than the space it sits in
     and undo the point of tightening it. */
  function closeBands(except) {
    document.querySelectorAll('.pdg-band-open').forEach(function (b) {
      if (b === except) return;
      b.classList.remove('pdg-band-open');
      var t = b.querySelector('.pdg-disclose');
      if (t) t.setAttribute('aria-expanded', 'false');
    });
  }

  function openPress() {
    var press = q('press'), btn = q('contactBtn');
    if (!press) return;
    press.classList.add('pdg-open');
    press.setAttribute('aria-hidden', 'false');
    if (btn) btn.setAttribute('aria-expanded', 'true');
    var first = q('pName');
    if (first) first.focus();
  }

  function closePress() {
    var press = q('press'), btn = q('contactBtn');
    if (!press) return;
    press.classList.remove('pdg-open');
    press.setAttribute('aria-hidden', 'true');
    // focus always returns to the Contact button — it is the only opener, and
    // Safari and Firefox do not focus a button on click, so activeElement at
    // open time is unreliable.
    if (btn) { btn.setAttribute('aria-expanded', 'false'); btn.focus(); }
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || typeof t.closest !== 'function') return;

    // accordion — one branch open per level, siblings close
    var grpBtn = t.closest('.pdg-grp > button.pdg-item');
    if (grpBtn) {
      var li = grpBtn.parentElement;
      var open = !li.classList.contains('pdg-open');
      li.parentElement.querySelectorAll(':scope > .pdg-grp.pdg-open').forEach(function (s) {
        if (s !== li) setOpen(s, false);
      });
      setOpen(li, open);
      return;
    }

    var link = t.closest('a.pdg-item');
    if (link) {
      document.querySelectorAll('.pdg-item.pdg-is-current').forEach(function (c) {
        c.classList.remove('pdg-is-current');
      });
      link.classList.add('pdg-is-current');
      if (link.getAttribute('href') === '#new') {
        document.querySelectorAll('.pdg-grp').forEach(function (g) { setOpen(g, false); });
      }
      return;
    }

    var disc = t.closest('.pdg-disclose');
    if (disc) {
      var band = disc.closest('.pdg-band');
      if (band) {
        var willOpen = !band.classList.contains('pdg-band-open');
        closeBands(band);
        band.classList.toggle('pdg-band-open', willOpen);
        disc.setAttribute('aria-expanded', String(willOpen));
      }
      return;
    }

    if (t.closest('#contactBtn')) { openPress(); return; }
    if (t.closest('#pressClose')) { closePress(); return; }
    if (t.id === 'press') { closePress(); return; }   // backdrop

    var menuBtn = t.closest('#menuBtn');
    if (menuBtn) {
      var rail = q('pdg-rail');
      if (!rail) return;
      var isOpen = rail.classList.toggle('pdg-open-menu');
      menuBtn.setAttribute('aria-expanded', String(isOpen));
      menuBtn.textContent = isOpen ? 'Close' : 'Menu';
    }
  });

  document.addEventListener('keydown', function (e) {
    var press = q('press');
    if (!press || !press.classList.contains('pdg-open')) return;

    if (e.key === 'Escape') { closePress(); return; }
    if (e.key !== 'Tab') return;

    // keep Tab inside the dialog while it is open
    var f = press.querySelectorAll('button, [href], input, textarea');
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  /* The form posts to Shopify, which answers with a full page load — so the
     dialog the visitor submitted from is closed and the outcome renders inside
     a visibility:hidden overlay. Reopen for BOTH outcomes: the error branch is
     the one that actually matters, since a silent failure loses the inquiry. */
  function revealResult() {
    if (document.querySelector('[data-pdg-posted], [data-pdg-error]')) openPress();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', revealResult);
  } else {
    revealResult();
  }

  /* Native validation shows an unstyled browser tooltip that vanishes on the
     next click. Mark the field instead, put the reason under it, and move focus
     to the first failure. Submit still goes to Shopify — this only gates it. */
  /* "How did you hear about us?" — delegated like everything else here, because
     the theme editor replaces this section's DOM on every settings change.
     The options are buttons; the answer is carried by a hidden input, which is
     the thing that actually posts. Choosing folds the panel away and leaves the
     answer on the line, so a completed form never reads as an empty one. */
  document.addEventListener('click', function (e) {
    var opt = e.target.closest('[data-pdg-hdy-opt]');
    if (opt) {
      var fld = opt.closest('[data-pdg-hdy]');
      if (!fld) return;
      var was = opt.getAttribute('aria-pressed') === 'true';
      fld.querySelectorAll('[data-pdg-hdy-opt]').forEach(function (o) {
        o.setAttribute('aria-pressed', 'false');
      });
      opt.setAttribute('aria-pressed', was ? 'false' : 'true');
      var value = was ? '' : opt.getAttribute('data-pdg-hdy-opt');
      var input = fld.querySelector('[data-pdg-hdy-input]');
      if (input) input.value = value;
      var ans = fld.querySelector('[data-pdg-hdy-ans]');
      if (ans) ans.textContent = value;
      fld.classList.toggle('pdg-has-ans', !!value);
      if (value) {
        /* let the press state land before folding, or the tap looks ignored */
        setTimeout(function () {
          fld.classList.remove('pdg-open');
          var ask = fld.querySelector('.pdg-hdy-ask');
          if (ask) ask.setAttribute('aria-expanded', 'false');
        }, 260);
      }
      return;
    }
    var ask = e.target.closest('.pdg-hdy-ask');
    if (ask) {
      var f = ask.closest('[data-pdg-hdy]');
      if (!f) return;
      var open = f.classList.toggle('pdg-open');
      ask.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
  });

  var pressForm = document.getElementById('pressForm');
  if (pressForm) {
    pressForm.setAttribute('novalidate', '');
    pressForm.addEventListener('submit', function (e) {
      var first = null;
      var req = pressForm.querySelectorAll('[required]');
      for (var i = 0; i < req.length; i++) {
        var el = req[i], fld = el.closest('.pdg-fld');
        var bad = !el.value.trim() ||
          (el.type === 'email' && !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(el.value));
        if (fld) fld.classList.toggle('pdg-err', bad);
        if (bad && !first) first = el;
      }
      if (first) { e.preventDefault(); first.focus(); return; }
      /* a slow connection invites a second press and a duplicate inquiry */
      var btn = pressForm.querySelector('.pdg-send');
      if (btn) { btn.disabled = true; btn.textContent = 'Sending\u2026'; }
    });
    pressForm.addEventListener('input', function (e) {
      var fld = e.target.closest('.pdg-fld');
      if (fld && fld.classList.contains('pdg-err') && e.target.value.trim()) {
        fld.classList.remove('pdg-err');
      }
    });
  }
})();
